<div class="d-flex align-items-center">
  <div class="rounded-img">
    <ng-content select="[title1]"></ng-content>
    <ng-content select="[title2]"></ng-content>
  </div>
  <div class="mb-0">
    <div class="q-tab-title pt-2">
      <ng-content select="[title3]"></ng-content>
    </div>
    <div class="q-tab-desc pt-2">
      <ng-content select="[title4]"></ng-content>
    </div>
    <div class="q-tab-desc">
      <ng-content select="[title5]"></ng-content>
    </div>
  </div>
</div>

<div class="errMessage signup-pending text-xs mb-1 text-center">
  <ng-content select="[title6]"></ng-content>
</div>
<div class="text-center reshare-link">
  <ng-content select="[btn1]"></ng-content>
</div>